var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62963 7.63059C12.329 2.93129 18.8263 0.0214844 25.9997 0.0214844C33.1731 0.0214844 39.6703 2.93129 44.3697 7.6306C49.069 12.33 51.9788 18.8273 51.9788 26.0007C51.9788 33.174 49.069 39.6713 44.3697 44.3707C39.6703 49.07 33.1731 51.9798 25.9997 51.9798C18.8263 51.9798 12.329 49.07 7.62963 44.3707C2.93033 39.6713 0.0205078 33.174 0.0205078 26.0007C0.0205078 18.8273 2.93034 12.33 7.62963 7.63059ZM25.9997 3.64648C19.8263 3.64648 14.2402 6.14658 10.1929 10.1939C6.14558 14.2412 3.64551 19.8273 3.64551 26.0007C3.64551 32.174 6.1456 37.7601 10.1929 41.8074C14.2402 45.8547 19.8263 48.3548 25.9997 48.3548C32.173 48.3548 37.7591 45.8547 41.8064 41.8074C45.8537 37.7601 48.3538 32.174 48.3538 26.0007C48.3538 19.8273 45.8537 14.2412 41.8064 10.1939C37.7591 6.14658 32.173 3.64648 25.9997 3.64648Z",
    fill: "#787395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9997 41.709C27.668 41.709 29.0205 40.3565 29.0205 38.6882C29.0205 37.0198 27.668 35.6673 25.9997 35.6673C24.3313 35.6673 22.9788 37.0198 22.9788 38.6882C22.9788 40.3565 24.3313 41.709 25.9997 41.709Z",
    fill: "#787395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9997 9.68815C27.0007 9.68815 27.8122 10.4996 27.8122 11.5007V30.834C27.8122 31.835 27.0007 32.6465 25.9997 32.6465C24.9987 32.6465 24.1872 31.835 24.1872 30.834V11.5007C24.1872 10.4996 24.9987 9.68815 25.9997 9.68815Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/info-gray.a7988169.svg";
export { ForwardRef as ReactComponent };